import React from 'react';
export const ModelErrorsModal = ({
  model,
  onClose,
  onBackToModel
}) => {
  // Sample error data for the Future Trend model
  const errors = [{
    id: 1,
    type: 'Model Validation',
    message: 'Insufficient data for accurate prediction',
    timestamp: '2023-05-15 09:12 AM'
  }, {
    id: 2,
    type: 'Model Validation',
    message: 'Outlier detection threshold exceeded',
    timestamp: '2023-05-15 09:14 AM'
  }];
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-665">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-666">
        <div className="flex justify-between items-center border-b border-gray-200 px-6 py-4" data-id="element-667">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-668">
            Errors: {model.name}
          </h3>
          <button className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-669">
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-670">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-671" />
            </svg>
          </button>
        </div>
        <div className="p-6" data-id="element-672">
          <button className="flex items-center text-blue-600 hover:text-blue-800 mb-4" onClick={onBackToModel} data-id="element-673">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor" data-id="element-674">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" data-id="element-675" />
            </svg>
            Back to Model
          </button>
          <div className="flex items-center mb-4" data-id="element-676">
            <div className="h-8 w-8 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-677">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-678">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-679" />
              </svg>
            </div>
            <h4 className="font-medium text-gray-900" data-id="element-680">Error Details</h4>
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-681">
            {model.errorCount} errors found in this model.
          </p>
          <div className="space-y-4 mb-6" data-id="element-682">
            {errors.map(error => <div key={error.id} className="border border-red-200 rounded-md p-4" data-id="element-683">
                <div className="flex items-start" data-id="element-684">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mr-2 mt-0.5" viewBox="0 0 20 20" fill="currentColor" data-id="element-685">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-686" />
                  </svg>
                  <div className="flex-1" data-id="element-687">
                    <div className="flex justify-between" data-id="element-688">
                      <h5 className="font-medium text-gray-900" data-id="element-689">
                        {error.type}
                      </h5>
                      <span className="text-xs text-gray-500" data-id="element-690">
                        {error.timestamp}
                      </span>
                    </div>
                    <p className="text-sm text-red-600 mt-1" data-id="element-691">{error.message}</p>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="flex justify-end gap-3" data-id="element-692">
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" data-id="element-693">
              Export Error Log
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-694">
              Fix Errors
            </button>
          </div>
        </div>
      </div>
    </div>;
};